import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_7 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_8 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_9 = { class: "flex min-w-0 flex-col justify-end md:col-span-2" }
const _hoisted_10 = { class: "flex flex-wrap items-end gap-2 md:col-span-12" }
const _hoisted_11 = { class: "md:col-span-12" }
const _hoisted_12 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_13 = { class: "text-sm font-medium text-slate-500" }
const _hoisted_14 = { class: "relative flex w-full max-w-[420px]" }
const _hoisted_15 = { class: "max-w-[560px] whitespace-pre-wrap leading-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Danh sách góp ý" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Từ thời gian", -1)),
                  _createVNode(_component_Calendar, {
                    modelValue: $setup.timeFrom,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.timeFrom) = $event)),
                    showTime: "",
                    placeholder: "Chọn thời gian bắt đầu"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, "Đến thời gian", -1)),
                  _createVNode(_component_Calendar, {
                    modelValue: $setup.timeTo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.timeTo) = $event)),
                    showTime: "",
                    placeholder: "Chọn thời gian kết thúc"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "Phân loại", -1)),
                  _createVNode(_component_Dropdown, {
                    modelValue: $setup.selectedFeedbackKindId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedFeedbackKindId) = $event)),
                    options: $setup.feedbackKindOptions,
                    optionLabel: "content",
                    optionValue: "id",
                    placeholder: "Tất cả",
                    filter: true,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadFeedback()))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    label: "Làm mới danh sách",
                    icon: "pi pi-refresh",
                    iconPos: "left",
                    loading: $setup.isLoading,
                    disabled: !$setup.timeFrom || !$setup.timeTo,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.loadFeedback()))
                  }, null, 8, ["loading", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    label: "Hôm nay",
                    outlined: "",
                    onClick: $setup.selectToday
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    label: "7 ngày gần nhất",
                    outlined: "",
                    onClick: $setup.selectLast7Days
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    label: "Tháng này",
                    outlined: "",
                    onClick: $setup.selectThisMonth
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createVNode(_component_DataTable, {
              loading: $setup.isLoading,
              value: $setup.listFeedbackDetail,
              paginator: true,
              rows: 10,
              filters: $setup.filters,
              "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (($setup.filters) = $event))
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-[15px] font-black text-slate-900" }, " Nội dung góp ý ", -1)),
                    _createElementVNode("div", _hoisted_13, " Tổng số: " + _toDisplayString($setup.listFeedbackDetail.length) + " góp ý ", 1)
                  ]),
                  _createElementVNode("span", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                    _createVNode(_component_InputText, {
                      class: "!pl-8 !pr-3",
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên, số điện thoại hoặc nội dung"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "fullName",
                  header: "Họ và tên",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "phoneNumber",
                  header: "Số điện thoại",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "kind",
                  header: "Phân loại",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.kind || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "content",
                  header: "Nội dung"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(data.content || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "time",
                  header: "Thời gian gửi",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.time)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "value", "filters"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}